import { render, staticRenderFns } from "./PreTriageDialog.vue?vue&type=template&id=089e7ac6&scoped=true"
import script from "./PreTriageDialog.vue?vue&type=script&lang=ts"
export * from "./PreTriageDialog.vue?vue&type=script&lang=ts"
import style0 from "../../styles/pre-triage-dialog.css?vue&type=style&index=0&id=089e7ac6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089e7ac6",
  null
  
)

export default component.exports